import type { AnalyticsStrategy } from '../types';
import { AmplitudeProvider } from './AmplitudeProvider';
import { BrazeProvider } from './BrazeProvider';
import { GoogleAnalyticsProvider } from './GoogleAnalyticsProvider';

export const AMPLITUDE_PROVIDER = Object.freeze(new AmplitudeProvider());
export const GOOGLE_ANALYTICS_PROVIDER = Object.freeze(new GoogleAnalyticsProvider());

export const BRAZE_PROVIDER = Object.freeze(new BrazeProvider());

export const providers = Object.freeze<AnalyticsStrategy[]>([
  AMPLITUDE_PROVIDER,
  GOOGLE_ANALYTICS_PROVIDER,
  BRAZE_PROVIDER,
]);
